import React, { useState } from "react";
import "./index.scss";
import InsuranceDetails from "./components";
import { formatAmount } from "../../../../utils/helper";
import PolicyEraImg from "../../../../assets/images/image 1 (1).png";
import PolicyModal from "../modal/policyModal";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../components/common/button";
import { openModal } from "../../../../store/slices/commonSlice";
import { setOrderId } from "../../../../store/slices/orders/ordersSlice";
import Card from "../../../../components/cardView";

const ProductCard = ({ productDetail, index, code }) => {
  const [isDetailsVisible, setIsDetailsVisible] = useState(false);
  const toggleDetailsVisibility = () => {
    setIsDetailsVisible(!isDetailsVisible);
  };
  const dispatch = useDispatch();
  const modalShow = useSelector((state) => state.common.modalShow);
  const selectedProductId = useSelector(
    (state) => state.orders.selectedOrder.id
  );
  const handlePolicyModal = (entityId) => {
    dispatch(openModal(true));
    dispatch(setOrderId(entityId));
  };
  const detailsData = useSelector(
    (state) => state.orders.selectedOrder.detailsData
  );

  const headerContent = (
    <>
      <div>
        <img
          src={
            productDetail?.oem_media_url
              ? productDetail?.oem_media_url
              : PolicyEraImg
          }
          className="product-variant-image"
          alt="Product Variant"
        />
      </div>
      <div className={`insurance--category ${(productDetail.product_category === "Insurance") ? "" : "secondary"}`}>
        {productDetail.product_category}
      </div>
    </>
  );

  const bodyContent = (
    <div className="insurance--product--card--content">
      {/* <div className="insurance--code">#{productDetail.code}</div> */}
      <div className="insurance--card--data">
        <div className="card--content--title">{productDetail.name}</div>
        <div className="card--content--title">
          {formatAmount(productDetail.premium_amount)}
        </div>
      </div>
      <div className="insurance--card--data">
        <div className="card--content--subtitle">
          {productDetail.oem_name
            ? productDetail.oem_name
            : productDetail.psp_name}
        </div>
      </div>
    </div>
  );

  const footerContent = (
    <div>
      <InsuranceDetails
        productInfo={productDetail.product_info}
        isVisible={isDetailsVisible}
      />
      {productDetail.product_category === "Insurance" &&
        detailsData.Policy_detail && (
          <div className="insurance--footer--button">
            <Button
              className="renew-button"
              onClick={() => handlePolicyModal(productDetail?.entityid)}
              type="button"
              variant="primary"
              label="Policy Details"
            />
          </div>
        )}
    </div>
  );
  return (
    <div className="product-detail-view">
      <Card
        headerContent={headerContent}
        bodyContent={bodyContent}
        footerContent={footerContent}
        isDetailsVisible={isDetailsVisible}
        toggleDetailsVisibility={toggleDetailsVisibility}
        upscale_type={"RECOMMENDED"}
      />
      {modalShow && selectedProductId === productDetail.entityid && (
        <PolicyModal code={code} productId={productDetail.entityid} />
      )}
    </div>
  );
};

export default ProductCard;
